export enum PlanTypes {
  PREMIUM = "Premium",
  STARTER = "Starter",
}
